import { getDate } from "src/utils/Date";

export interface IAssemblyDocumentTitle {
    title: string;
    date: string;
}

const UMLAUT_REPLACEMENTS: Record<string, string> = {
    Ä: "Ae",
    Ö: "Oe",
    Ü: "Ue",
    ä: "ae",
    ö: "oe",
    ü: "ue",
    ß: "ss"
};

const FILE_NAME_SPECIAL_CHARACTERS = /["'`^=?.,%+ç$><()#&]/g;

const getAsciiSafeAssemblyTitle = (title: string) =>
    title
        .replace(/[ÄÖÜäöüß]/g, (character) => UMLAUT_REPLACEMENTS[character])
        .replace(FILE_NAME_SPECIAL_CHARACTERS, "");

export const getAssemblyDocumentDisplayName = (
    fileName: string | null | undefined,
    assemblyDocumentTitles: IAssemblyDocumentTitle[]
) => {
    if (!fileName) {
        return fileName;
    }

    const matchingAssembly = assemblyDocumentTitles.find((assemblyDocumentTitle) => {
        const assemblyDate = getDate(assemblyDocumentTitle.date);
        const asciiSafeTitle = getAsciiSafeAssemblyTitle(assemblyDocumentTitle.title);

        return Boolean(
            assemblyDate &&
                asciiSafeTitle &&
                fileName.includes(assemblyDate) &&
                fileName.includes(asciiSafeTitle)
        );
    });

    if (!matchingAssembly) {
        return fileName;
    }

    return fileName.replace(getAsciiSafeAssemblyTitle(matchingAssembly.title), matchingAssembly.title);
};
